import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import MuiButton from '@material-ui/core/Button';
import { get } from 'lodash-es';
import Loading from './Loading';

const clrs = {
  primary: 'PLColor1',
};
const PlButton = styled(MuiButton)`
  && {
    position: relative;
    .MuiButton-label {
      min-height: 24px;
    }
    ${({ theme }) => theme.typography.button()}
    text-transform: none;
    font-weight: 600;
    font-size: 15px;
    letter-spacing: 0;
    ${({ paylo, paylobg, fullWidth }) => {
      const isBgColor = get(clrs, paylobg);
      return (
        paylo &&
        css`
          background: #1e293b;
          border-radius: 12px;
          box-shadow: 0 2px 8px rgba(15, 23, 42, 0.15);
          border: 0;
          max-width: ${fullWidth ? 'auto' : '300px'};
          min-width: 295px;
          padding: 16px 24px;
          position: relative;
          transition: all 0.15s ease;
          &:hover,
          &:active {
            background: #0f172a;
            box-shadow: 0 4px 12px rgba(15, 23, 42, 0.25);
          }
        `
      );
    }}
    ${({ paylo, variant, theme: { color } }) => {
      if (paylo && variant && variant === 'outlined') {
        return css`
          color: ${({ theme: { color } }) => color.PLColor1};
          &::after {
            background: ${({ theme: { color } }) => color.white_500};
            border-radius: 30px;
            content: '';
            height: calc(100% - 6px);
            left: 50%;
            opacity: 1;
            top: 50%;
            transition: opacity 0.3s ease-in;
            position: absolute;
            width: calc(100% - 6px);
            z-index: 2;
            transform: translate(-50%, -50%);
          }
          &:disabled {
            background: ${({ theme: { color } }) => color.white_800};
            border: 0;
          }
          &:hover:not([disabled])::after {
            opacity: 0.9;
          }
          &:active:not([disabled])::after {
            opacity: 0.6;
          }
        `;
      } else if (paylo && variant && variant === 'contained') {
        return css`
          color: ${({ theme: { color } }) => color.white_500};
          &::before {
            background: ${({ theme: { color } }) => color.gray_700};
            border-radius: 30px;
            content: '';
            height: 100%;
            left: 0;
            opacity: 0;
            top: 0;
            transition: opacity 0.3s ease-in;
            position: absolute;
            width: 100%;
            z-index: 1;
          }
          &:disabled {
            background: ${({ theme: { color } }) => color.white_700};
            color: ${({ theme: { color } }) => color.white_500};
          }
          &:hover:not([disabled])::before {
            opacity: 0.2;
          }
          &:active:not([disabled])::before {
            opacity: 0.4;
          }
        `;
      } else if (paylo && variant && variant === 'text') {
        return css`
          color: ${({ theme: { color } }) => color.gray_400};
          border: 0;
          box-shadow: none;
          min-width: auto;
          &:hover {
            background: none;
            text-decoration: underline;
          }
        `;
      }
    }}
  }
`;
const TextSpan = styled.span`
  z-index: 3;
  ${({ paylo, variant, theme: { color } }) => {
    if (paylo && variant && variant === 'outlined') {
      return css`
        background: ${`linear-gradient(to right, ${color.PLGradient})`};
        color: ${color.PLColor1}
        -webkit-text-fill-color: transparent;
        -webkit-box-decoration-break: clone;
        background-clip: text;
        -webkit-background-clip: text;
      `;
    }
  }}
  ${({ paylo, variant, theme: { color }, disabled }) => {
    if (paylo && variant && variant === 'outlined' && disabled) {
      return css`
        background: ${({ theme: { color } }) => color.white_800};
        color: ${color.PLColor1}
        -webkit-text-fill-color: transparent;
        -webkit-box-decoration-break: clone;
        background-clip: text;
        -webkit-background-clip: text;
      `;
    }
  }}
`;

const PlLoading = (props) => <Loading {...props} />;

const Button = ({ children, loading, loadingColor, type, paylo, ...rest }) => {
  return (
    <PlButton {...rest} type={type} paylo={paylo ? 1 : 0} disableRipple>
      {loading ? <PlLoading color={loadingColor} /> : <TextSpan>{children}</TextSpan>}
    </PlButton>
  );
};
Button.propTypes = {
  paylo: PropTypes.bool,
  disabled: PropTypes.bool,
  children: PropTypes.node,
  fullWidth: PropTypes.bool,
  variant: PropTypes.oneOf(['text', 'outlined', 'contained']),
  loading: PropTypes.bool,
  loadingColor: PropTypes.string,
  type: PropTypes.string,
  paylobg: PropTypes.oneOf(['default', 'primary']),
};
Button.defaultProps = {
  loadingColor: '#2867B5',
  paylobg: 'default',
};
export default Button;
